import React from "react";
import { graphql, useFragment } from "react-relay";

import { faUsers } from "@awesome.me/kit-4c83d50d0d/icons/kit/custom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import MenuLink, { type MenuLinkProps } from "~/nav/panels/Home/Links/MenuLink";

import type { TeamLink_info$key as Team } from "~/__generated__/TeamLink_info.graphql";

import styles from "~/nav/panels/shared/PanelSection.module.css";

export default function TeamLink(
	props: Omit<MenuLinkProps, "to" | "innerRef" | "activeClassName"> & {
		team: Team;
		innerRef?: React.Ref<HTMLAnchorElement>;
	},
) {
	const { team: teamProp, innerRef, ...restProps } = props;
	const team = useFragment(
		graphql`
			fragment TeamLink_info on Team {
				id
				title
				archived
				url
			}
		`,
		teamProp,
	);

	return (
		<MenuLink
			{...restProps}
			innerRef={innerRef}
			to={team.url}
			activeClassName={styles.active}
			data-test-id="teams-link"
			icon={<FontAwesomeIcon icon={faUsers} fixedWidth />}
			iconTooltip="Team"
		>
			<span title={team.title} className={styles.title}>
				{team.title}
			</span>
		</MenuLink>
	);
}
